import '../../../../App.css';
import Sliders from "../../../ui/tables-slider/sliders/Sliders";

function MarketAnalysisTabs({slidersContent, language}) {
    return (
        <>
            {slidersContent && (
                <div className='component-container-no-full-height'>
                    <div className='component-data-container'>
                        <Sliders
                            slidersContent={slidersContent}
                            isMarket={false}
                            isBlog={false}
                            isMarketAnalysis={true}
                            language={language}
                        />
                    </div>
                </div>
            )}
        </>
    );
}

export default MarketAnalysisTabs;